var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:_vm.inputClass,attrs:{"id":_vm.id,"size":_vm.size,"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.formattedValue},on:{"input":function($event){return _vm.handleEvent('input', $event)},"change":function($event){return _vm.handleEvent('change', $event)},"keydown":_vm.handleKeydown}})
}
var staticRenderFns = []

export { render, staticRenderFns }